export default "__VITE_ASSET__CbU931j5__"